import React from "react";

import "../styles/arrowCorner.scss";

const Arrow = props => {
  return (
    <div
      className={"arrowCorner arrowCorner--" + props.direction}
      style={{ left: props.x, bottom: props.y }}
    >
      <div className="arrowCorner--head" />
      <div
        className={"arrowCorner--tail"}
        style={{ height: props.lengths[0] + "vw" }}
      />
      <div
        className={"arrowCorner--tail arrowCorner--tail--second"}
        style={{
          top: props.lengths[0] + "vw",
          height: props.lengths[1] + "vw"
        }}
      />
    </div>
  );
};

export default Arrow;
